// import React, { Component } from "react";
// import { Card, Input, Select, Button, Upload, Typography, Modal } from "antd";
// import { UploadOutlined, SendOutlined } from "@ant-design/icons";
// import { withTranslation } from "react-i18next";
// import { openNotificationDuration } from "../../utils";

// const { TextArea } = Input;
// const { Title, Text } = Typography;

// class TicketSystem extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       category: "Technical",
//       description: "",
//       fileList: [], // Ant Design ใช้ fileList ในการจัดการไฟล์
//       isLoading: false,
//       statusMsg: "",
//       isError: false,
//       isModalOpen: false,
//     };

//     this.CONFIG = {
//       TOKEN: "8457346777:AAFE9Ysh2a28aw7Y0miu__poI2Fu5SGdMI4",
//       CHAT_ID: "-5143672878",
//     };
//   }

//   // จัดการฟิลด์ทั่วไป
//   handleChange = (id, value) => {
//     this.setState({ [id]: value });
//   };

//   // จัดการการอัปโหลดรูป
//   handleUploadChange = ({ fileList }) => {
//     // เก็บเฉพาะรูปที่เลือกไว้ใน State
//     this.setState({ fileList });
//   };

//   submitTicket = async () => {
//     const { category, description, fileList } = this.state;
//     const { resProfileAdmin, nameMerchang } = this.props;

//     const username = resProfileAdmin?.username;
//     const merchant = nameMerchang;

//     // Validation
//     if (!username || !merchant || !description) {
//       openNotificationDuration(
//         "warning",
//         10,
//         "Warning",
//         "Please fill in all the required information.",
//       );
//       this.setState({
//         statusMsg: "Please fill in all the required information.",
//         isError: true,
//         isLoading: false,
//       });
//       return;
//     }

//     this.setState({ isLoading: true });

//     const textTemplate = `
// 🎫 **New Ticket Received!**

// 👤 **USERNAME:** ${username}
// 🏠 **MERCHANT:** ${merchant}
// 📁 **CATEGORY:** ${category}
// 📝 **DESCRIPTION:** ${description}

// 📅 *Sent at: ${new Date().toLocaleString("th-TH")}*
//     `;

//     try {
//       const formData = new FormData();
//       formData.append("chat_id", this.CONFIG.CHAT_ID);
//       formData.append("parse_mode", "Markdown");

//       let url = `https://api.telegram.org/bot${this.CONFIG.TOKEN}/sendMessage`;

//       // ตรวจสอบว่ามีไฟล์ใน fileList หรือไม่
//       if (fileList.length > 0) {
//         url = `https://api.telegram.org/bot${this.CONFIG.TOKEN}/sendPhoto`;
//         // originFileObj คือไฟล์จริงที่ได้จาก Ant Design Upload
//         formData.append("photo", fileList[0].originFileObj);
//         formData.append("caption", textTemplate);
//       } else {
//         formData.append("text", textTemplate);
//       }

//       const response = await fetch(url, {
//         method: "POST",
//         body: formData,
//       });

//       if (response.ok) {
//         openNotificationDuration(
//           "success",
//           20,
//           "Success",
//           "Ticket successfully submitted! Our team will process it as soon as possible.",
//         );
//         this.setState(
//           {
//             description: "",
//             fileList: [],
//             isError: false,
//             isLoading: false,
//           },
//           () => this.props.handleCancel(),
//         );
//       } else {
//         throw new Error("Telegram API Error");
//       }
//     } catch (err) {
//       openNotificationDuration(
//         "error",
//         10,
//         "error",
//         "Data could not be sent. Please try again.",
//       );
//       this.setState({
//         statusMsg: "An error occurred during data transmission.",
//         isError: true,
//         isLoading: false,
//       });
//     }
//   };
//   onCancel = () => {
//     const { handleCancel } = this.props;
//     this.setState(
//       {
//         isModalOpen: false,
//         statusMsg: "",
//         isError: false,
//         isLoading: false,
//       },
//       () => handleCancel(),
//     );
//   };
//   render() {
//     const { category, description, fileList, statusMsg, isError, isLoading } =
//       this.state;
//     const { resProfileAdmin, nameMerchang, isModalOpen } = this.props;

//     const username = resProfileAdmin?.username || "N/A";
//     const merchant = nameMerchang || "N/A";

//     return (
//       <>
//         <Modal
//           title="Add ticket"
//           closable={{ "aria-label": "Custom Close Button" }}
//           open={isModalOpen}
//           onCancel={this.onCancel}
//           maskClosable={false}
//           style={{ top: 20 }}
//           width={568}
//           footer={[]}
//         >
//           <div
//             style={{
//               padding: "20px",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <Card
//               style={{
//                 width: "100%",
//                 maxWidth: 500,
//                 borderRadius: 15,
//                 boxShadow: "0 4px 12px rgba(0, 0, 0, 0)",
//                 border: "1px solid #00000000",
//               }}
//             >
//               <div style={{ textAlign: "center", marginBottom: 20 }}>
//                 <Title level={3} style={{ color: "#0088cc" }}>
//                   Report problem
//                 </Title>
//               </div>
//               <div style={{ marginBottom: 15 }}>
//                 <Text strong>Username / Merchant</Text>
//                 <Input
//                   value={`${username} (${merchant})`}
//                   disabled
//                   style={{ marginTop: 5 }}
//                 />
//               </div>
//               <div style={{ marginBottom: 15 }}>
//                 <Text strong>Category</Text>
//                 <Select
//                   style={{ width: "100%", marginTop: 5 }}
//                   value={category}
//                   onChange={(value) => this.handleChange("category", value)}
//                   options={[
//                     { value: "General", label: "General (ทั่วไป)" },
//                     { value: "DEPOSIT", label: "DEPOSIT (ฝากเงิน)" },
//                     { value: "WITHDRAW", label: "WITHDRAW (ถอนเงิน)" },
//                     { value: "BankAccount", label: "BANK ACCOUNT (บัญชีธนาคาร)" },
//                     { value: "Technical", label: "Technical / Bug (ปัญหาเทคนิค / บัค)" },
//                   ]}
//                 />
//               </div>
//               <div style={{ marginBottom: 15 }}>
//                 <Text strong>Description</Text>
//                 <TextArea
//                   rows={4}
//                   placeholder="Describe the problem...."
//                   value={description}
//                   onChange={(e) =>
//                     this.handleChange("description", e.target.value)
//                   }
//                   style={{ marginTop: 5 }}
//                 />
//               </div>
//               <div style={{ marginBottom: 25 }}>
//                 <Text strong>Attach image</Text>
//                 <div style={{ marginTop: 5 }}>
//                   <Upload
//                     listType="picture"
//                     fileList={fileList}
//                     onChange={this.handleUploadChange}
//                     beforeUpload={() => false} // ป้องกันไม่ให้ auto upload
//                     maxCount={5} // ส่งทีละรูป
//                   >
//                     <Button icon={<UploadOutlined />}>Select image</Button>
//                   </Upload>
//                 </div>
//               </div>
//               <Button
//                 type="primary"
//                 icon={<SendOutlined />}
//                 size="large"
//                 block
//                 loading={isLoading}
//                 onClick={this.submitTicket}
//                 style={{ backgroundColor: "#0088cc", borderRadius: 8 }}
//               >
//                 Submit to Support group
//               </Button>{" "}
//               {statusMsg && (
//                 <div
//                   style={{
//                     marginTop: "15px",
//                     textAlign: "center",
//                     color: isError ? "red" : "green",
//                   }}
//                 >
//                   {statusMsg}
//                 </div>
//               )}
//             </Card>
//           </div>
//         </Modal>
//       </>
//     );
//   }
// }

// export default withTranslation()(TicketSystem);
import React, { Component } from "react";
import {
  Input,
  Select,
  Button,
  Upload,
  Typography,
  Modal,
  Image,
  Tag,
} from "antd";
import { UploadOutlined, SendOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import { openNotificationDuration } from "../../utils";

const { TextArea } = Input;
const { Title, Text } = Typography;

// Helper function สำหรับแปลงไฟล์เป็น Base64
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const escapeHTML = (str) =>
  str.replace(
    /[&<>"']/g,
    (m) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      })[m],
  );
class TicketSystem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: "General",
      description: "",
      fileList: [],
      isLoading: false,
      statusMsg: "",
      isError: false,
      previewOpen: false,
      previewImage: "",
      previewTitle: "",
    };

    this.CONFIG = {
      TOKEN: "8457346777:AAFE9Ysh2a28aw7Y0miu__poI2Fu5SGdMI4",
      CHAT_ID: "-5143672878",
    };
  }

  // ฟังก์ชันจัดการการ Preview
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewOpen: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  handleCancelPreview = () => this.setState({ previewOpen: false });
  handleChange = (id, value) => {
    this.setState({ [id]: value });
  };
  handleTagClick = (tagName) => {
    const { description } = this.state;
    // ปรับการต่อคำ: ถ้ามีข้อความอยู่แล้ว ให้เติมคอมม่าก่อนตามด้วย Tag ใหม่
    const trimmedDesc = description.trim();
    const newDescription = trimmedDesc
      ? trimmedDesc.endsWith(",")
        ? `${trimmedDesc} ${tagName}`
        : `${trimmedDesc}, ${tagName}`
      : tagName;

    this.setState({ description: `${newDescription}, ` }); // เติมคอมม่าและ space ไว้รอคำถัดไป
  };

  handleUploadChange = ({ fileList }) => {
    this.setState({ fileList });
  };

  submitTicket = async () => {
    const { category, description, fileList } = this.state;
    const { resProfileAdmin, nameMerchang, handleCancel } = this.props;
    const username = resProfileAdmin?.username;
    const merchant = nameMerchang;

    if (!username || !merchant || !description) {
      openNotificationDuration(
        "warning",
        10,
        "Warning",
        "Please fill in all the required information.",
      );
      return;
    }

    this.setState({ isLoading: true });
    const safeDescription = escapeHTML(description);
    const safeUsername = escapeHTML(username);
    const textTemplate = `
<b>🎟 แจ้งปัญหาระบบ PAYEASY: 🕐 ${new Date().toLocaleString("th-TH")} 🕐</b>

<b>SENDER:</b> <em>${safeUsername} (${merchant})</em>,
<b>CATEGORY:</b> <em>${category}</em>,
<b>DESCRIPTION:</b> ${safeDescription}

`;

    try {
      // Logic ส่ง Telegram (เหมือนเดิม)
      const formData = new FormData();
      formData.append("chat_id", this.CONFIG.CHAT_ID);
      formData.append("parse_mode", "HTML");

      let url = `https://api.telegram.org/bot${this.CONFIG.TOKEN}/sendMessage`; 

      if (fileList.length > 0) {
        url = `https://api.telegram.org/bot${this.CONFIG.TOKEN}/sendPhoto`;
        formData.append("photo", fileList[0].originFileObj);
        formData.append("caption", `${textTemplate}`);
      } else {
        formData.append("text", `${textTemplate}`);
      }

      const response = await fetch(`${url}`, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        const errorData = await response.json();
        this.setState({ isLoading: false });
        openNotificationDuration(
          "error",
          10,
          `Error ${errorData.error_code || ""}`,
          errorData.description || "Telegram API Error",
        );
        return;
      }

      // ส่งรูปที่เหลือ (2-3)
      if (fileList.length > 1) {
        for (let i = 1; i < fileList.length; i++) {
          const extraPhotoData = new FormData();
          extraPhotoData.append("chat_id", this.CONFIG.CHAT_ID);
          extraPhotoData.append("photo", fileList[i].originFileObj);
          await fetch(
            `https://api.telegram.org/bot${this.CONFIG.TOKEN}/sendPhoto`,
            {
              method: "POST",
              body: extraPhotoData,
            },
          );
        }
      }

      openNotificationDuration(
        "success",
        20,
        "Success",
        "Ticket successfully submitted! Our team will process it as soon as possible.",
      );
      this.setState({ description: "", fileList: [], isLoading: false }, () =>
        handleCancel(),
      );
    } catch (err) {
      openNotificationDuration("error", 10, "Error", "Connection failed.");
      console.log(err);
      this.setState({ isLoading: false });
    }
  };

  onCancel = () => {
    this.setState(
      {
        description: "", // ล้างข้อมูลเมื่อกดปิด เพื่อไม่ให้ค้างตอนเปิดใหม่
        fileList: [],
        statusMsg: "",
        isError: false,
        isLoading: false,
        category: "General",
      },
      () => this.props.handleCancel(),
    );
  };

  render() {
    const {
      category,
      description,
      fileList,
      isLoading,
      previewOpen,
      previewImage,
    } = this.state;
    const { resProfileAdmin, nameMerchang, isModalOpen } = this.props;

    const username = resProfileAdmin?.username || "N/A";
    const merchant = nameMerchang || "N/A";
    const maxFiles = 3;

    const tagsByCategory = {
      General: ["หน้าเว็ปโหลดช้า", "เมนูไม่แสดง"],
      DEPOSIT: ["บัญชีฝากไม่ดึง", "ฝากไม่ออโต้", "ฝากเงินซ้ำ"],
      WITHDRAW: ["ถอนเงินช้า", "ถอนสำเร็จแต่เงินไม่เข้าลูกค้า", "ถอนเงินซ้ำ"],
      VERIFY_SLIP: ["อัพสลิปไม่ได้", "อัพสลิปแล้วเงินไม่เข้า", "สลิปซ้ำ"],
      BankAccount: ["เพิ่มบัญชีไม่ได้", "ลบบัญชีไม่ได้", "ยอดเงินไม่อัพเดท"],
    };

    return (
      <Modal
        title={null}
        open={isModalOpen}
        onCancel={this.onCancel}
        maskClosable={false}
        style={{ top: 20 }}
        width={568}
        footer={null}
        destroyOnClose
      >
        <div style={{ padding: "10px" }}>
          <Title level={4} style={{ textAlign: "center", color: "#0088cc" , textTransform:"uppercase"}}>
            Report Problem
          </Title>

          <div style={{ marginBottom: 15 }}>
            <Text strong>Username / Merchant</Text>
            <Input
              value={`${username} (${merchant})`}
              disabled
              style={{ marginTop: 5 }}
            />
          </div>

          <div style={{ marginBottom: 15 }}>
            <Text strong>Category</Text>
            <Select
              style={{ width: "100%", marginTop: 5 }}
              value={category}
              onChange={(value) => this.handleChange("category", value)}
              options={[
                { value: "General", label: "General (ทั่วไป)" },
                { value: "DEPOSIT", label: "DEPOSIT (ฝากเงิน)" },
                { value: "WITHDRAW", label: "WITHDRAW (ถอนเงิน)" },
                { value: "VERIFY_SLIP", label: "VERIFY SLIP (ตรวจสอบสลิป)" },
                { value: "BankAccount", label: "BANK ACCOUNT (บัญชีธนาคาร)" },
              ]}
            />
          </div>

          <div style={{ marginBottom: 15 }}>
            <Text strong>Description</Text>
            <TextArea
              rows={4}
              placeholder="Describe the problem...."
              value={description}
              onChange={(e) => this.handleChange("description", e.target.value)}
              style={{ marginTop: 5 }}
            />

            {tagsByCategory[category] && (
              <div style={{ marginTop: 10 }}>
                <Text
                  type="secondary"
                  size="small"
                  style={{ display: "block", marginBottom: 5 }}
                >
                  Quick select:
                </Text>
                {tagsByCategory[category].map((tag) => (
                  <Tag
                    key={tag}
                    style={{ cursor: "pointer", marginBottom: 5 }}
                    onClick={() => this.handleTagClick(tag)}
                  >
                    {tag}
                  </Tag>
                ))}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 25 }}>
            <Text strong>Attach Images (Max {maxFiles - fileList.length})</Text>
            <div style={{ marginTop: 5 }}>
              <Upload
                listType="picture-card" // เปลี่ยนเป็น picture-card เพื่อให้ดูง่ายเวลาอัปโหลดหลายรูป
                fileList={fileList}
                onPreview={this.handlePreview} // เพิ่มฟังก์ชัน Preview
                onChange={this.handleUploadChange}
                beforeUpload={() => false}
                maxCount={maxFiles}
              >
                {fileList.length < maxFiles && (
                  <div>
                    <UploadOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
              {previewImage && (
                <Image
                  wrapperStyle={{ display: "none" }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) =>
                      this.setState({ previewOpen: visible }),
                    afterOpenChange: (visible) =>
                      !visible && this.setState({ previewImage: "" }),
                  }}
                  src={previewImage}
                />
              )}
            </div>
          </div>

          <Button
            type="primary"
            icon={<SendOutlined />}
            size="middle"
            block
            loading={isLoading}
            onClick={this.submitTicket}
            style={{
              backgroundColor: "#0088cc",
              borderRadius: 8,
            }}
          >
            Submit to Support Group
          </Button>
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(TicketSystem);
